/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2023-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

// List of all keys that are valid for all client types
// TODO: The list of whitelisted keys needs to be extended to include
//       handling of application specific keys, not only platform specific keys
export const WHITELISTED_KEYS_SHARED = [
  'APP_DEFAULT_LOCALE',
  'FEATURE_FAMILY_SHARING_ACTIVE',
  'FEATURE_SKOOBE_ACTIVE',
  'OAUTH_CLIENT_ID',
  'OAUTH_SCOPE_FAMILY',
  'OAUTH_SCOPE',
  'OAUTH_TOKEN_DEMO_USER',
  'STORE_SHELF_TOKENS',
  'URL_ADVERTISEMENT',
  'URL_API',
  'URL_APP_DEVICE_MANAGEMENT',
  'URL_APP_HANDSHAKE',
  'URL_BACKEND_BOSH',
  'URL_BACKEND_FAMILY',
  'URL_BACKEND_INVENTORY',
  'URL_BOOKSHELF',
  'URL_DEVICE_MANAGEMENT',
  'URL_DISCOVER',
  'URL_DISCOVER_SAMPLE',
  'URL_DISCOVER_RECOMMENDATIONS',
  'URL_INVENTORY',
  'URL_MANUAL_FAMILY_SHARING',
  'URL_OAUTH_ACCESSTOKEN_FAMILY',
  'URL_OAUTH_ACCESSTOKEN',
  'URL_OAUTH_AUTHAPP',
  'URL_OAUTH_AUTHORIZATION',
  'URL_OAUTH_AUTOLOGIN',
  'URL_OAUTH_REDIRECT',
  'URL_OAUTH_REVOKETOKEN',
  'URL_OAUTH_SESSIONKILLER',
  'URL_RESELLER_CONTACT',
  'URL_RESELLER_DATA_PRIVACY',
  'URL_RESELLER_HELP',
  'URL_RESELLER_IMPRINT_DOCUMENT',
  'URL_RESELLER_TERMS_AND_CONDITIONS',
  'URL_SKOOBE_BOOK_RETURN',
  'URL_SKOOBE_DEVICE_MANAGEMENT',
  'URL_SKOOBE_NOTIFY_USER',
  'URL_SKOOBE_POLLING',
  'URL_SKOOBE_READING_DATA',
  'URL_SKOOBE_REGISTER_ERROR',
  'URL_SKOOBE_REGISTER',
  'URL_SKOOBE_SHOP',

  // SONICCHAIR
  'URL_PARAMS_TRACKING'
];

// List of keys that are valid for all client types and who start with any of
// the strings defined in this array
export const WHITELISTED_KEYS_PLACEHOLDERS = [
  'OAUTH_X_'
];

// List of keys that are valid for Android applications only
export const WHITELISTED_KEYS_ANDROID = [
  'URL_APP_LICENSES_DOCUMENT'
];

// List of keys that are valid for iOS applications only
export const WHITELISTED_KEYS_IOS = [
  'URL_APP_LICENSES_DOCUMENT'
];

// List of keys that are valid for Web applications only
export const WHITELISTED_KEYS_WEB = [
  'URL_SHOP_AUDIO_SEARCH',
  'URL_SHOP_AUDIO_START_PAGE',
  'URL_SHOP_EBOOK_SEACH',
  'URL_SHOP_EBOOK_START_PAGE',
  'URL_SHOP_RECOMMENDATIONS_BASE',
  'URL_SHOP_SEARCH_BASE',
  'URL_SHOP_START_PAGE'
];
